// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tabs-view[data-v-6973a7d0]{border-bottom:1px solid #d9dadb;margin:0 0 15px}.tabs-view ul[data-v-6973a7d0]{margin:0;padding:0 10px;text-align:center;display:table;width:100%;table-layout:fixed;position:relative;top:1px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
